import { render } from "./Produkter.vue?vue&type=template&id=3b11ccbe&scoped=true"
import script from "./Produkter.vue?vue&type=script&lang=js"
export * from "./Produkter.vue?vue&type=script&lang=js"

import "./Produkter.vue?vue&type=style&index=0&id=3b11ccbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b11ccbe"]])

export default __exports__